import { render, staticRenderFns } from "./EditGroups.vue?vue&type=template&id=a80818a2&scoped=true&"
import script from "./EditGroups.vue?vue&type=script&lang=js&"
export * from "./EditGroups.vue?vue&type=script&lang=js&"
import style0 from "./EditGroups.vue?vue&type=style&index=0&id=a80818a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80818a2",
  null
  
)

export default component.exports